import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const MenuIcon = ({ size = defaultSize, ...otherProps }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...otherProps}
  >
    <path
      clipRule="evenodd"
      d="M2 5C2 4.44772 2.44772 4 3 4H21C21.5523 4 22 4.44772 22 5C22 5.55228 21.5523 6 21 6H3C2.44772 6 2 5.55228 2 5ZM2 12C2 11.4477 2.44772 11 3 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12ZM2 19C2 18.4477 2.44772 18 3 18H21C21.5523 18 22 18.4477 22 19C22 19.5523 21.5523 20 21 20H3C2.44772 20 2 19.5523 2 19Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

MenuIcon.propTypes = {
  ...sizePropsTypes,
};

export default MenuIcon;
